import React from "react";
import { motion } from "framer-motion";
import { Section, SectionHeader } from "@/components/Section";
import { SERVICE_AREAS } from "@/lib/constants";
import { MapPin } from "lucide-react";

export const ServiceAreas = () => {
  return (
    <Section id="areas" testId="section-areas" className="bg-white/40">
      <div className="grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <SectionHeader
            kicker="Service Areas"
            title="Serving all major GTA cities."
            subtitle="GTA and surrounding area covered. Pickup and drop-off is included for lessons, with downtown extra."
            testId="areas-header"
          />

          <motion.ul
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className="mt-8 flex flex-wrap gap-2"
            data-testid="service-areas"
            aria-label="Cities served"
          >
            {SERVICE_AREAS.map((city) => (
              <li
                key={city}
                data-testid={`service-area-chip-${city.toLowerCase().replace(/\s+/g, "-")}`}
                className="inline-flex items-center gap-1.5 rounded-full border border-maple-border bg-maple-cream2 px-3.5 py-2 text-sm text-maple-navy/85 hover:border-maple-navy/30 hover:bg-white transition-colors"
              >
                <MapPin className="h-3.5 w-3.5 text-maple-brown" aria-hidden="true" />
                {city}
              </li>
            ))}
          </motion.ul>

          <p className="mt-6 text-sm text-maple-navy/75" data-testid="areas-disclaimer">
            Don't see your city? <a href="#contact" className="underline decoration-maple-brown/50 underline-offset-4 hover:text-maple-navy">Get in touch</a> - outside-GTA service has an extra charge based on distance, from $50 to $200.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97, y: 18 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-5"
        >
          <div className="relative rounded-3xl border border-maple-border overflow-hidden aspect-[4/5] hidden lg:block">
            <img
              src="https://images.pexels.com/photos/32015537/pexels-photo-32015537.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720"
              alt="Toronto skyline at dusk — the GTA we serve"
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-maple-navy/40 via-transparent to-transparent" />
            <span className="absolute bottom-4 left-4 inline-flex items-center gap-1.5 rounded-full bg-maple-cream/95 px-3 py-1.5 text-xs font-medium uppercase tracking-[0.14em] text-maple-navy">
              <MapPin className="h-3.5 w-3.5" aria-hidden="true" />
              Greater Toronto Area
            </span>
          </div>
        </motion.div>
      </div>
    </Section>
  );
};
